import { ANIMALS, generateEquationSeries, generateRandomNumberSeries, getSeriesFromCouples, shuffle } from "../../utils";
import { generatePathItems } from "../base/Path/pathutils";


export const RIGHTANSWERMESS2 = [
    'great', 'great01', 'great02', 'great03', 'great04', 'great05', 'great06', 'great07', 'great08', 'great09', 'great10',
];

export const WRONGANSWERMESS2 = [
    'nodiscorage', 'nodiscorage01', 'nodiscorage02', 'nodiscorage03', 'nodiscorage04', 'nodiscorage05', 'nodiscorage06', 'nodiscorage07', 'nodiscorage08', 'nodiscorage09', 'nodiscorage10',
];

export const getRandomMessage2 = (type) => {
    const idx = type === 'great' ? Math.floor(Math.random() * RIGHTANSWERMESS2.length) : Math.floor(Math.random() * WRONGANSWERMESS2.length);
    return type === 'great' ? RIGHTANSWERMESS2[idx] : WRONGANSWERMESS2[idx];
}

export const generateMemoSeries = (params) => {

    if (params.memoseries) return params.memoseries;
    else {
        let series = [];

        const configSeries = params.series;
        const couples = params ? params.couples : null;

        if (configSeries) {
            for (let idx = 0; idx < configSeries.length; idx++) {
                const aSerie = configSeries[idx];
                series.push(generateRandomNumberSeries(aSerie.num, aSerie.init, aSerie.finish));
            }
        } else {
            if (couples === 'random') {
                series = [generateRandomNumberSeries(params.num, params.init, params.finish)];
            } else {
                series = couples;
            }
        }

        // console.log(`generateMemoSeries:`, series);

        return series;
    }

}

export const getSumSubSeries = (params) => {
    const upperlimit = params.upperlimit ? params.upperlimit : (Math.pow(10, params.rows) - 1);
    const series = getSeriesFromCouples(params.couples, params.num, params.init, params.finish, params.ops, params.config, params.ispan, params.fspan, 0, upperlimit);
    // console.log(`getSumSubSeries:`, series);
    return series;
}

export const generateChallNumberSeries = (params) => {
    if (params.series) return params.series;
    const series = params ? generateRandomNumberSeries(params.num, params.init, params.finish, null) : generateRandomNumberSeries(9, 1, 9, null);
    return series;
}

export const generateMultDivSeries = (params) => {
    if (params.series) return params.series;
    const couples = params.couples;
    const series = getSeriesFromCouples(couples, params.num, params.init, params.finish, params.ops, params.config, params.ispan, params.fspan);
    return series;
}

export const generateTuples = (params) => {
    if (params.series && params.guess && params.numbers) return [params.series, params.guess, params.numbers];
    const permOperations = params.permOps ? params.permOps : ['+', '-', '*'];

    // console.log('generateTuples:', params, permOperations);

    const lseries = [];
    const guess = [];
    const numbers = [];

    for (let idx = 0; idx < params.num; idx++) {
        const aSerie = generateRandomNumberSeries(3, params.init, params.finish);
        numbers.push(aSerie);
        guess.push(shuffle(aSerie)[0]);
        const ops = shuffle(permOperations);
        const aNewSerie = [];
        for (let idy = 0; idy < ops.length; idy++) {
            const op = ops[idy];
            let e1 = aSerie[idy];
            let e2 = aSerie[idy == ops.length - 1 ? 0 : idy + 1];
            if (op == '-' && e1 < e2) {
                let t1 = e1;
                e1 = e2; e2 = t1;
            }
            aNewSerie.push(`${e1} ${op} ${e2}`);
        }
        lseries.push(aNewSerie);
    }

    return [lseries, guess, numbers];
}

export const generateCompleteEquationSeries = (params) => {
    if (params.series) return params.series;
    const init = params.init | 21;
    const finish = params.finish | 99;
    const series = generateEquationSeries(params.num, params.ops, init, finish, params.permOps, 'simple');
    return series;
}

export const generateAnimalsSeries = (params) => {
    if (params.series) return params.series;
    shuffle(ANIMALS);
    const objects = ANIMALS.slice(0, params.num_objects);

    return objects;
}

export const generateNumPathSeries = (params) => {
    const [lItems, lSolution, llastPos] = (params.lItems && params.llastPos && params.lSolution) ? [params.lItems, params.lSolution, params.llastPos] : generatePathItems(params.items, params.ispan, params.fspan, params.value, params.cols, params.rows, { x: 0, y: 0 }, { x: params.rows - 1, y: params.cols - 1 });

    return [lItems, lSolution, llastPos];
}

export const generateCompleteEquationsSeries = (params) => {
    if (params.series) return params.series;
    const init = params.init | 21;
    const finish = params.finish | 99;
    const series = generateEquationSeries(params.num, params.ops, init, finish, params.permOps);
    return series;
}
